import { FeaturesEnum } from '~/features/types';
import { PermissionEnum } from '~/roles/types';

export default [
  {
    path: '/workflows',
    meta: {
      auth: true,
      permissions: [PermissionEnum.WORKFLOWS],
      feature: FeaturesEnum.WORKFLOWS,
    },
    component: () => import('~/common/layouts/default.vue'),
    children: [
      {
        path: '',
        name: 'workflows',
        component: () => import('~/workflows/pages/Workflows.vue'),
      },
      {
        path: '/workflow/:id?',
        name: 'workflowEngine',
        component: () => import('~/workflows/pages/WorkflowEngine/Index.vue'),
        props(route) {
          let props = { ...route.params };
          return props;
        },
      },
    ],
  },
];
